<template>
  <div>
    <h2 v-if="showContent"> {{ album.name }}</h2>
    <p v-if="album.description">
      {{ album.description }}
    </p>
    <div id="myCarouselAlbumDetail" class="carousel slide" data-ride="carousel" v-if="showContent">
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-target="#myCarouselAlbumDetail" :data-slide-to="index" :class="index == 0 ? 'active' : ''"
            v-for="(slider, index) in album.images"></li>
      </ol>

      <!-- Wrapper for slides -->
      <div class="carousel-inner">
        <div :class="index == 0 ? 'item active' : 'item'" v-for="(slider, index) in album.images">
          <img :src="slider.imageCover" class="imagemalbum">
        </div>
      </div>

      <!-- Left and right controls -->
      <a class="left carousel-control" href="#myCarouselAlbumDetail" data-slide="prev">
        <span class="glyphicon glyphicon-chevron-left"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="right carousel-control" href="#myCarouselAlbumDetail" data-slide="next">
        <span class="glyphicon glyphicon-chevron-right"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <br>
    <comentarios v-show="album.comments == 1" :comments="album.comentarios" :tipo="tipo" :referencia="album.id"></comentarios>
  </div>
</template>

<script>

  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';
  import AlbumInterno from "../components/interno/AlbumInterno";
  import Comentarios from "./Comentarios";


  export default {
    name: "AlbumDetails",
    components: {Comentarios, AlbumInterno},
    data() {
      return {
        tipo:'album',
        album: {},
        images: null,
        showContent: false,
      }
    },
    mounted() {
      let self = this;
      get('album-details/' + this.$route.params.id).then(function (response) {
        self.album = response.data.result.data;
        self.showContent = true;
      });
    },
    activated () {
      let self = this;
      self.showContent = false;
      get('album-details/' + this.$route.params.id).then(function (response) {
        self.album = response.data.result.data;
        self.showContent = true;
      });
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/AlbumDetails.vue